export type ClipType = "m3u8" | "mp4"

export function getClippingUrl(args: { edgeUrl: string; streamKey: string; from: Date; to: Date; type: ClipType }) {
  const { edgeUrl, streamKey, from, to, type } = args
  const fromEncoded = encodeURIComponent(from.toISOString())
  const toEncoded = encodeURIComponent(to.toISOString())

  const path = type === "m3u8" ? "multivariant.m3u8" : "mp4"

  return `${edgeUrl}/v1/clipping/${streamKey}/${path}?from=${fromEncoded}&to=${toEncoded}`
}

export function getClippingUrlByChannelId(args: {
  edgeUrl: string
  channelId: string
  from: Date
  to: Date
  authToken: string
  type: ClipType
  download?: boolean
}) {
  const { edgeUrl, channelId, from, to, authToken, type, download } = args
  const fromEncoded = encodeURIComponent(from.toISOString())
  const toEncoded = encodeURIComponent(to.toISOString())

  const path = type === "m3u8" ? "multivariant.m3u8" : "mp4"

  const url = `${edgeUrl}/v1/clipping/${channelId}/${path}?from=${fromEncoded}&to=${toEncoded}&authToken=${authToken}`
  return download ? `${url}&download` : url
}
